export const SET_SETTINGS = "SET_SETTINGS";